/* caragins 광고 안내 페이지 — 조선일보 스타일 참고 */

const S = {
  pageTitle: { fontFamily: 'Noto Serif KR, Georgia, serif', fontWeight: 900, fontSize: '28px', color: '#1A1A1A', letterSpacing: '-0.02em' },
  sectionTitle: { fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '16px', color: '#1A1A1A' },
  label: { fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '11px', color: '#DD0000' },
  body: { fontFamily: 'Noto Sans KR, sans-serif', fontSize: '13px', color: '#444', lineHeight: 1.7 },
  mono: { fontFamily: 'IBM Plex Mono, monospace', fontSize: '11px', color: '#888' },
};

function SectionHeader({ title, sub }) {
  return (
    <div style={{ borderTop: '3px solid #1A1A1A', padding: '10px 0 14px', marginBottom: '20px' }}>
      <h2 style={S.sectionTitle}>{title}</h2>
      {sub && <p style={{ ...S.mono, marginTop: '4px' }}>{sub}</p>}
    </div>
  );
}

const adProducts = [
  {
    type: '메인 배너',
    position: '홈 상단 최상위 노출',
    size: '1140 × 150 px',
    format: 'JPG · PNG · GIF · HTML5',
    exposure: '전체 독자 100%',
    price: '월 300만원~',
    badge: 'HOT',
    badgeColor: '#DD0000',
    desc: '플랫폼 접속 시 가장 먼저 보이는 프리미엄 광고 슬롯. 브랜드 인지도 극대화에 최적.',
  },
  {
    type: '기사 내 광고',
    position: '기사 본문 중간 삽입',
    size: '680 × 100 px',
    format: 'JPG · PNG · GIF',
    exposure: '기사 열람 독자',
    price: '월 150만원~',
    badge: 'BEST',
    badgeColor: '#1A1A1A',
    desc: '기사를 읽는 독자에게 자연스럽게 노출. 콘텐츠 몰입 중 광고 효과 극대화.',
  },
  {
    type: '사이드바 광고',
    position: '우측 사이드바 고정',
    size: '268 × 200 px',
    format: 'JPG · PNG',
    exposure: '스크롤 전 구간',
    price: '월 80만원~',
    badge: null,
    badgeColor: null,
    desc: '뉴스 열람 내내 우측에 고정 노출되는 스티키 광고. 클릭율 업계 평균 2.3배.',
  },
  {
    type: '동물병원 전용',
    position: '펫케어 섹션 + 사이드바',
    size: '268 × 300 px',
    format: 'JPG · PNG · HTML5',
    exposure: '펫케어 독자 집중 타겟',
    price: '월 120만원~',
    badge: 'NEW',
    badgeColor: '#4CAF50',
    desc: '반려동물 관심 독자에게만 노출되는 타겟팅 광고. 동물병원·펫샵 전문 지면.',
  },
  {
    type: '스폰서드 기사',
    position: '뉴스 피드 내 자연 노출',
    size: '기사 형식',
    format: '텍스트 + 이미지',
    exposure: '전체 독자 피드',
    price: '건당 200만원~',
    badge: 'PR',
    badgeColor: '#0066CC',
    desc: '광고임을 표시하되 기사 형식으로 제공되는 네이티브 광고. 독자 신뢰도 활용.',
  },
  {
    type: '풀페이지 광고',
    position: '페이지 전환 시 전면',
    size: '전체 화면',
    format: 'HTML5 · 영상',
    exposure: '세션당 1회',
    price: '월 500만원~',
    badge: 'PREMIUM',
    badgeColor: '#7C3AED',
    desc: '페이지 이동 시 전면 노출되는 임팩트 광고. 캠페인·이벤트 단기 집중 노출에 적합.',
  },
];

const placements = [
  { zone: 'A', name: '메인 배너', color: '#DD0000', top: '2%', left: '5%', width: '90%', height: '10%' },
  { zone: 'B', name: '사이드바', color: '#1A1A1A', top: '18%', left: '78%', width: '18%', height: '45%' },
  { zone: 'C', name: '기사 내 광고', color: '#0066CC', top: '52%', left: '5%', width: '70%', height: '8%' },
  { zone: 'D', name: '하단 배너', color: '#4CAF50', top: '88%', left: '5%', width: '90%', height: '8%' },
];

const specs = [
  { item: '파일 형식',   val: 'JPG, PNG, GIF (애니메이션), HTML5, MP4' },
  { item: '최대 용량',   val: '이미지 500KB · HTML5 2MB · 영상 10MB' },
  { item: '해상도',      val: '72dpi 이상 · Retina 대응 2x 권장' },
  { item: '링크',        val: 'https 필수 · 외부 랜딩 페이지 가능' },
  { item: '소재 제출',   val: '게재 7일 전까지 (HTML5는 10일 전)' },
  { item: '심의',        val: '제출 후 영업일 2일 이내 검토 완료' },
  { item: '수정 횟수',   val: '월 2회 무료 · 이후 건당 5만원' },
  { item: '통계 제공',   val: '노출수 · 클릭수 · CTR 실시간 대시보드' },
];

const packages = [
  {
    name: 'STARTER',
    price: '월 100만원',
    color: '#888',
    items: ['사이드바 광고 1개월', '기사 내 광고 5회', '기본 통계 리포트', '소재 제작 가이드'],
  },
  {
    name: 'STANDARD',
    price: '월 300만원',
    color: '#1A1A1A',
    items: ['메인 배너 1개월', '사이드바 광고 1개월', '스폰서드 기사 1건', '실시간 통계 대시보드', '담당 매니저 배정'],
    highlight: true,
  },
  {
    name: 'PREMIUM',
    price: '월 700만원',
    color: '#DD0000',
    items: ['풀페이지 광고 포함 전 상품', '동물병원 전용 타겟팅', '스폰서드 기사 3건', '월간 성과 보고서', '전담 컨설턴트 + 소재 제작 지원'],
  },
];

const faqs = [
  { q: '광고 계약 최소 기간이 있나요?', a: '최소 1개월 단위로 계약 가능합니다. 3개월 이상 계약 시 10%, 6개월 이상 시 20% 할인이 적용됩니다.' },
  { q: '광고 소재를 직접 제작해드리나요?', a: 'STANDARD 이상 패키지에는 기본 소재 검토 및 가이드 제공이 포함됩니다. 별도 제작 의뢰 시 추가 견적을 안내드립니다.' },
  { q: '특정 지역·연령·관심사 타겟팅이 가능한가요?', a: '동물병원 전용 상품의 경우 펫케어 섹션 방문 독자 대상 타겟팅이 기본 포함됩니다. 추가 타겟팅 조건은 별도 문의 바랍니다.' },
  { q: '광고 효과 측정은 어떻게 하나요?', a: '모든 광고 상품에 노출수·클릭수·CTR 통계가 제공됩니다. STANDARD 이상은 실시간 대시보드 접근 권한이 부여됩니다.' },
];

export default function Advertisement({ onBack }) {
  return (
    <div style={{ background: 'white', minHeight: '100vh' }}>

      {/* 페이지 헤더 */}
      <div style={{ borderBottom: '3px solid #1A1A1A' }}>
        <div className="max-w-7xl mx-auto px-6" style={{ paddingTop: '28px', paddingBottom: '20px' }}>
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div>
              <span style={S.label}>■ 광고 안내</span>
              <h1 style={{ ...S.pageTitle, marginTop: '6px' }}>caragins 광고 상품 안내</h1>
              <p style={{ ...S.body, marginTop: '8px', color: '#666' }}>
                일 평균 12만 명이 방문하는 caragins에서 브랜드와 서비스를 알리세요.<br />
                반려동물 관심 독자에게 최적화된 타겟 광고를 제공합니다.
              </p>
            </div>
            <button onClick={onBack}
              style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#888', background: 'none', border: '1px solid #DDD', padding: '6px 14px', cursor: 'pointer', flexShrink: 0 }}>
              ← 홈으로
            </button>
          </div>

          {/* 핵심 지표 */}
          <div className="grid grid-cols-2 md:grid-cols-4" style={{ gap: '0', marginTop: '24px', border: '1px solid #E5E5E5' }}>
            {[
              { n: '12만+', label: '일 평균 방문자', sub: 'UV 기준' },
              { n: '38만+', label: '월 페이지뷰', sub: 'PV 기준' },
              { n: '4.2분', label: '평균 체류 시간', sub: '업계 평균 2배' },
              { n: '62%', label: '반려동물 관심 독자', sub: '펫케어 섹션 방문 기준' },
            ].map((s, i) => (
              <div key={i} style={{ padding: '16px 20px', borderRight: (i % 2 === 0) ? '1px solid #E5E5E5' : 'none', borderBottom: i < 2 ? '1px solid #E5E5E5' : 'none', textAlign: 'center' }}>
                <p style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 900, fontSize: '26px', color: '#DD0000', lineHeight: 1 }}>{s.n}</p>
                <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', color: '#1A1A1A', marginTop: '5px' }}>{s.label}</p>
                <p style={{ ...S.mono, marginTop: '3px' }}>{s.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6" style={{ paddingTop: '32px', paddingBottom: '32px' }}>

        {/* 광고 상품 */}
        <SectionHeader title="광고 상품" sub="모든 상품은 VAT 별도 · 최소 1개월 단위 계약" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3" style={{ gap: '0', border: '1px solid #E5E5E5', marginBottom: '40px' }}>
          {adProducts.map((p, i) => (
            <div key={i} style={{
              padding: '20px',
              borderRight: i % 3 < 2 ? '1px solid #E5E5E5' : 'none',
              borderBottom: i < 3 ? '1px solid #E5E5E5' : 'none',
              background: 'white',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <h3 style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '14px', color: '#1A1A1A' }}>{p.type}</h3>
                {p.badge && (
                  <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '9px', fontWeight: 700, color: 'white', background: p.badgeColor, padding: '2px 7px', letterSpacing: '0.1em' }}>
                    {p.badge}
                  </span>
                )}
              </div>
              <p style={{ ...S.body, fontSize: '12px', marginBottom: '14px', color: '#666' }}>{p.desc}</p>

              {/* 스펙 */}
              <div style={{ background: '#F7F7F7', padding: '10px 12px', fontSize: '11px', fontFamily: 'Noto Sans KR, sans-serif', lineHeight: 1.8 }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <span style={{ color: '#AAA', minWidth: '44px' }}>위치</span>
                  <span style={{ color: '#333' }}>{p.position}</span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <span style={{ color: '#AAA', minWidth: '44px' }}>크기</span>
                  <span style={{ color: '#333', fontFamily: 'IBM Plex Mono, monospace' }}>{p.size}</span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <span style={{ color: '#AAA', minWidth: '44px' }}>형식</span>
                  <span style={{ color: '#333' }}>{p.format}</span>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <span style={{ color: '#AAA', minWidth: '44px' }}>노출</span>
                  <span style={{ color: '#333' }}>{p.exposure}</span>
                </div>
              </div>

              <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 900, fontSize: '16px', color: '#DD0000' }}>{p.price}</span>
                <a href="/#" style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '11px', color: '#555', border: '1px solid #DDD', padding: '4px 12px', textDecoration: 'none' }}>
                  문의하기
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* 광고 위치 시각화 */}
        <SectionHeader title="광고 노출 위치" sub="caragins 홈페이지 기준 — 실제 노출 위치를 시각적으로 확인하세요" />
        <div className="flex flex-col md:flex-row" style={{ gap: '32px', marginBottom: '40px', alignItems: 'flex-start' }}>
          {/* 페이지 레이아웃 미리보기 */}
          <div style={{ flex: 1, border: '1px solid #E5E5E5', background: '#FAFAFA', position: 'relative', height: '420px', minWidth: 0 }}>
            {/* 네비 영역 */}
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '12%', background: '#1A1A1A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '9px', color: 'rgba(255,255,255,0.4)' }}>NAVBAR</span>
            </div>
            {/* 광고 영역들 */}
            {placements.map(z => (
              <div key={z.zone} style={{
                position: 'absolute',
                top: z.top, left: z.left, width: z.width, height: z.height,
                background: z.color,
                opacity: 0.85,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '9px', color: 'white', fontWeight: 700, letterSpacing: '0.1em' }}>
                  {z.zone} · {z.name}
                </span>
              </div>
            ))}
            {/* 콘텐츠 영역 */}
            <div style={{ position: 'absolute', top: '18%', left: '5%', width: '70%', height: '30%', background: '#E8E8E8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '9px', color: '#999' }}>기사 콘텐츠 영역</span>
            </div>
          </div>

          {/* 범례 */}
          <div className="w-full md:w-[220px] md:flex-shrink-0">
            <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', color: '#1A1A1A', marginBottom: '12px' }}>광고 영역 범례</p>
            {placements.map(z => (
              <div key={z.zone} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 0', borderBottom: '1px solid #F0F0F0' }}>
                <div style={{ width: '28px', height: '28px', background: z.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '10px', color: 'white', fontWeight: 700 }}>{z.zone}</span>
                </div>
                <div>
                  <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', color: '#1A1A1A' }}>{z.name}</p>
                </div>
              </div>
            ))}
            <a href="/#" style={{ display: 'block', marginTop: '16px', background: '#DD0000', color: 'white', fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', padding: '10px 0', textDecoration: 'none', textAlign: 'center' }}>
              광고 문의하기 →
            </a>
          </div>
        </div>

        {/* 광고 소재 규격 */}
        <SectionHeader title="광고 소재 제작 규격" sub="소재 제출 전 반드시 확인하세요" />
        <div style={{ border: '1px solid #E5E5E5', marginBottom: '40px' }}>
          {specs.map((r, i) => (
            <div key={i} style={{ display: 'flex', borderBottom: i < specs.length - 1 ? '1px solid #F0F0F0' : 'none' }}>
              <div style={{ width: '140px', flexShrink: 0, padding: '11px 16px', background: '#F7F7F7', borderRight: '1px solid #E5E5E5' }}>
                <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', color: '#1A1A1A' }}>{r.item}</span>
              </div>
              <div style={{ flex: 1, padding: '11px 16px' }}>
                <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '12px', color: '#444' }}>{r.val}</span>
              </div>
            </div>
          ))}
        </div>

        {/* 패키지 */}
        <SectionHeader title="광고 패키지" sub="패키지 계약 시 최대 30% 할인 적용" />
        <div className="grid grid-cols-1 md:grid-cols-3" style={{ gap: '16px', marginBottom: '40px' }}>
          {packages.map((pkg, i) => (
            <div key={i} style={{
              border: pkg.highlight ? '2px solid #1A1A1A' : '1px solid #E5E5E5',
              padding: '24px',
              position: 'relative',
              background: pkg.highlight ? '#FAFAFA' : 'white',
            }}>
              {pkg.highlight && (
                <div style={{ position: 'absolute', top: '-1px', left: '20px', background: '#1A1A1A', color: 'white', fontFamily: 'IBM Plex Mono, monospace', fontSize: '9px', padding: '3px 10px', letterSpacing: '0.1em' }}>
                  RECOMMENDED
                </div>
              )}
              <p style={{ fontFamily: 'IBM Plex Mono, monospace', fontWeight: 700, fontSize: '13px', color: pkg.color, letterSpacing: '0.15em', marginBottom: '8px' }}>{pkg.name}</p>
              <p style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 900, fontSize: '22px', color: '#1A1A1A', marginBottom: '16px' }}>{pkg.price}</p>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px' }}>
                {pkg.items.map((item, j) => (
                  <li key={j} style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', color: '#444', padding: '5px 0', borderBottom: '1px solid #F0F0F0', display: 'flex', gap: '8px' }}>
                    <span style={{ color: '#DD0000', flexShrink: 0 }}>✓</span> {item}
                  </li>
                ))}
              </ul>
              <a href="/#" style={{
                display: 'block', textAlign: 'center',
                background: pkg.highlight ? '#1A1A1A' : 'transparent',
                color: pkg.highlight ? 'white' : '#555',
                border: `1px solid ${pkg.highlight ? '#1A1A1A' : '#DDD'}`,
                fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px',
                padding: '10px 0', textDecoration: 'none',
              }}>
                상담 신청
              </a>
            </div>
          ))}
        </div>

        {/* FAQ */}
        <SectionHeader title="자주 묻는 질문" />
        <div style={{ border: '1px solid #E5E5E5', marginBottom: '40px' }}>
          {faqs.map((f, i) => (
            <div key={i} style={{ padding: '16px 20px', borderBottom: i < faqs.length - 1 ? '1px solid #E5E5E5' : 'none' }}>
              <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '13px', color: '#1A1A1A', marginBottom: '6px' }}>
                <span style={{ color: '#DD0000', marginRight: '8px' }}>Q.</span>{f.q}
              </p>
              <p style={{ ...S.body, fontSize: '12px', paddingLeft: '20px' }}>
                <span style={{ color: '#888', marginRight: '8px' }}>A.</span>{f.a}
              </p>
            </div>
          ))}
        </div>

        {/* 광고 문의 */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" style={{ background: '#1A1A1A', padding: '32px', gap: '24px' }}>
          <div>
            <p style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '10px', color: 'rgba(255,255,255,0.4)', letterSpacing: '0.2em', marginBottom: '8px' }}>CONTACT</p>
            <p style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 900, fontSize: '22px', color: 'white', marginBottom: '6px' }}>광고 문의</p>
            <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '13px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
              담당자가 영업일 1일 이내에 연락드립니다.<br />
              광고 집행 규모에 따라 별도 할인 협의 가능합니다.
            </p>
            <div style={{ display: 'flex', gap: '24px', marginTop: '12px' }}>
              <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>ad@caragins.com</span>
              <span style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>02-0000-0000</span>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flexShrink: 0 }}>
            <a href="/#" style={{ display: 'block', background: '#DD0000', color: 'white', fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '13px', padding: '12px 28px', textDecoration: 'none', textAlign: 'center' }}>
              광고 문의하기 →
            </a>
            <a href="/#" style={{ display: 'block', border: '1px solid rgba(255,255,255,0.3)', color: 'rgba(255,255,255,0.7)', fontFamily: 'Noto Sans KR, sans-serif', fontSize: '12px', padding: '10px 28px', textDecoration: 'none', textAlign: 'center' }}>
              광고 제안서 다운로드
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}
